import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "../service";

export const addAssignedLicenseAction = createAsyncThunk(
  "admin/addAssignedLicenseAction",
  async (addAssignedLicenseData, { rejectWithValue }) => {
    try {
      const { admin_id } = JSON.parse(localStorage.getItem("userData"));
      const data = {
        id: Number(addAssignedLicenseData?.user),
        assign_product: addAssignedLicenseData?.product?.map(
          (item) => item?.id
        ),
        admin_id: admin_id,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_TEST_API}/node/update-user-in-node`,
        data,
        { headers: myHeaders() }
      );
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.clear();
        window.location.assign("/");
      }
      if (error) {
        return rejectWithValue(error.message);
      }
    }
  }
);
